import React from 'react'

function Kadra() {
  return (
    <div className='kadra-container'>
      <div className='kadra-overlay'>
      <h2>Kadra Grębałowianki Oldboi 2024</h2>
      

      <div className='kadra-card'>
      <h1>Bramkarze</h1>
       <p>Piotr Kokosza</p>
       <p>Dominik Nowak</p>
       <p></p>
      </div>

      <div className='kadra-card'>
         <h1>Obrońcy</h1>
       <p>Łukasz Korcala</p>
       <p>Paweł Ochlust</p>
       <p>Piotr Jańczyk</p>
       <p>Marcin Wierzbiński</p>
       <p>Konrad Poplatek</p>
       <p>Grzegorz Rutka</p>
       <p>Krzysztof Marzec</p>
       <p>Maciej Wejner</p>
       <p>Rafał Gruchała</p>
        </div>

      <div className='kadra-card'>
            <h1>Pomocnicy</h1>
       <p>Marcin Oleś</p>
       <p>Sebastian Towarek</p>
       <p>Lukasz Lampart</p>
       <p>Piotr Franaszek</p>
       <p>Marcin Cecuga</p>
       <p>Grzegorz Strojek</p>
       <p>Dominik Karaś</p>
       <p>Marcin Kawula</p>
        </div>

        <div className='kadra-card'>
        <h1>Napastnicy</h1>
       <p>Robert Strojek</p>
       <p>Andrzej Mucharski</p>
       <p>Piotr Grzywa</p>
       <p>Marcin Stolarski</p>
       <p>Arkadiusz Gadzina</p>
       <p></p>
        </div>
    

      <div className='kadra-card'>
         <h1>Trener</h1>
       <p>Bernard Łach</p>
       <h1> II Trener</h1>
       <p>Jerzy Ostrowski</p>
        <h1>Kapitan drużyny</h1>
        <p>Piotr Kokosza</p>
        <h1>Kierownik drużyny</h1>
       <p>Grzegorz Strojek / Robert Strojek</p>
       <h1>Grill Meni</h1>
       <p>Piotr Kokosza</p>
       <p>Marcin Stolarski</p>
       <p>Paweł Ochlust</p>
       <p>Grzegorz Strojek</p>
       <h1>Social Media</h1>
       <p>Piotr Grzywa / Marcin Oleś</p>
      </div>

      </div>
      

    </div>
  )
}

export default Kadra